import { extractReasons } from './json-api'
import { hasErrors } from './has-errors'

export const errorHandler = ({ errors }) => {
  if (!hasErrors({ errors })) {
    return {}
  }

  switch (errors.constructor) {
  case TypeError:
    return { summary: [errors.message] }
  case String:
    return { summary: [errors] }
  case Object:
    return extractReasons([errors])

  default:
    return extractReasons(errors)
  }
}



// WEBPACK FOOTER //
// ./src/io/error-handling/handler.js